class NewsletterBlock {
  /**
   * Add custom JavaScript to the block HTML.
   *
   * @param   Element  block       The block element
   * @param   object   attributes  The block attributes (only available when editing)
   * @return  void
   */
  constructor(block, attributes = null) {
    this.block = block;
    this.form = block.querySelector('.newsletter__form');
    this.success = block.querySelector('.newsletter__success');
    this.agreement = block.querySelector('input[name="formData[agreement]"]');
    this.agreementError = block.querySelector('.newsletter__checkbox-error');

    if (!this.form) {
      return;
    }

    this.group = this.form.querySelector('.newsletter__form-field');
    this.error = this.form.querySelector('.error-text');
    this.recaptcha = this.form.querySelector('input[data-recaptcha]');

    window._mfq = window._mfq || [];

    if (this.recaptcha && window.grecaptcha) {
      grecaptcha.ready(() => {
        this.refreshRecaptcha();
        setInterval(() => this.refreshRecaptcha(), 60000);
      });
    }

    this.form.addEventListener('submit', (e) => {
      e.preventDefault();

      if (!this.agreement.checked) {
        // this.agreementError.classList.add('has-errors');
        // return;
      } else {
        // this.agreementError.classList.remove('has-errors');
      }

      const formData = new FormData(this.form);
      formData.append('action', 'submit');

      this.form.classList.add('disabled');
      this.group.classList.remove('has-errors');
      this.error.innerHTML = '';

      window._mfq?.push(['formSubmitAttempt', `#${this.form.id}`]);

      fetch(ajaxurl, {
        method: 'POST',
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            window._mfq?.push(['formSubmitSuccess', `#${this.form.id}`]);

            this.form.style.height = this.form.scrollHeight + 'px';

            setTimeout(() => {
              this.form.style.height = 0;
              this.form.style.padding = 0;
              this.form.style.overflow = 'hidden';
              this.success.style.height = this.success.scrollHeight + 'px';
            }, 200);
          } else {
            window._mfq?.push(['formSubmitFailure', `#${this.form.id}`]);

            this.form.classList.remove('disabled');
            this.group.classList.add('has-errors');

            if (data.data['email']) {
              this.error.innerHTML = this.form.dataset.emailError ?? data.data['email'][0];
            }

            this.refreshRecaptcha();
          }
        });
    });
  }

  refreshRecaptcha() {
    if (this.recaptcha && !this.form.classList.contains('disabled')) {
      grecaptcha
        .execute(this.recaptcha.dataset.recaptcha, {
          action: 'homepage',
        })
        .then((token) => {
          this.recaptcha.value = token;
        });
    }
  }
}

// Initialize each block on page load (front end)
document.querySelectorAll('.newsletter').forEach((block) => {
  new NewsletterBlock(block);
});

// Initialize the dynamic block preview (editor)
if (window.acf) {
  window.acf.addAction('render_block_preview/type=newsletter', ($block, attributes) => {
    new NewsletterBlock($block.find('.newsletter').get(0), attributes);
  });
}

export { NewsletterBlock };